module.exports = __webpack_public_path__ + "static/trainDefault.ee54414f.png";